import DaasTableRowCell from '@/components/table/DaasTableRowCell';
import { Category } from '@/services/api/contracts/catalog/types';
import { FunctionComponent } from 'react';

interface Props {
  category: Category;
  manufacturerIds: string[];
}

export const PurchaseOrderConfirmOrderDeviceTableCategorySectionRow: FunctionComponent<Props> = ({
  category,
  manufacturerIds
}) => {
  return (
    <>
      <DaasTableRowCell className="border-r-0 justify-start text-lg font-medium">{category.name}</DaasTableRowCell>
      <DaasTableRowCell className="border-x-0"></DaasTableRowCell>

      <DaasTableRowCell className="border-x-0"></DaasTableRowCell>
      <DaasTableRowCell className="border-x-0"></DaasTableRowCell>
      <DaasTableRowCell className="border-x-0 relative h-[60px]">
        {/* Requirement in 30274 for this to be easily revertible. Uncomment if so*/}
        {/* <div className="absolute right-[20px]">
          {category.isMainDevice ? (
            <PurchaseOrderFinanceModelSection manufacturerIds={manufacturerIds} categoryId={category.id} />
          ) : (
            <PurchaseOrderPeripheralFinanceModelSection />
          )}
        </div> */}
      </DaasTableRowCell>
      <DaasTableRowCell className="border-l-0"></DaasTableRowCell>
    </>
  );
};
